import gql from 'graphql-tag';

export default class ActionPlanFragments {
  static task = gql`
    fragment taskFragment on Task {
      id
      title
      description
      deadline
      status
      createdAt
      updatedAt
      participantIds
      statusUpdatedBy
      statusUpdatedAt
    }
  `;

  static milestone = gql`
    fragment milestoneFragment on Milestone {
      id
      title
      description
      createdAt
      updatedAt
      tasks {
        ...taskFragment
      }
    }
    ${ActionPlanFragments.task}
  `;

  static milestones = gql`
    fragment milestonesFragment on ListMilestonesResult {
      milestones {
        ...milestoneFragment
      }
    }
    ${ActionPlanFragments.milestone}
  `;
}
